import { useEffect, useState } from 'react'

import { useAppSelector } from 'store/hooks'
import { CAPTCHA_DISABLED, getItemFormLocalStorageSelector } from 'utils/localStorage'

const shouldShowFakeCaptcha = process.env.SHOW_FAKE_CAPTCHA === 'true'

const useFakeCaptcha = () => {
  const [isVercelPreview, setIsVercelPreview] = useState(false)
  const captchaDisabledFlag = useAppSelector((state) => getItemFormLocalStorageSelector(state, CAPTCHA_DISABLED, false))
  const isProdProfile = process.env.PROFILE === 'prod'
  const isCaptchaDisabled = process.env.PROFILE === 'dev' && captchaDisabledFlag
  const isFakeCaptcha = !isProdProfile && (shouldShowFakeCaptcha || isCaptchaDisabled || isVercelPreview)

  useEffect(() => {
    // Keep hostname checks out of render: /login is server-rendered, and
    // deriving preview state only in the browser avoids SSR/hydration drift.
    if (typeof window === 'undefined') {
      return
    }

    const host = window.location.hostname

    setIsVercelPreview(host.endsWith('.vercel.app') || host === 'vercel.app')
  }, [])

  return isFakeCaptcha
}

export default useFakeCaptcha
